'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animate = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ComponentType} from 'react' */

var isBrowser = typeof window !== 'undefined';
var ScrollReveal = isBrowser ? require('scrollreveal').default : null;

// Componiendo el nombre para ajustarse a la recomendacion de ReactJs
// https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
function getDisplayName(BaseComponent) {
  return BaseComponent.displayName || BaseComponent.name || 'Component';
}

/*::
type AnimateProps = {
  animation?: Object,
}
*/
var animate = exports.animate = function animate(refName /*: string */) {
  return function (BaseComponent /*: ComponentType<*> */) {
    var Animated = function (_React$Component) {
      _inherits(Animated, _React$Component);

      function Animated() {
        _classCallCheck(this, Animated);

        return _possibleConstructorReturn(this, (Animated.__proto__ || Object.getPrototypeOf(Animated)).apply(this, arguments));
      }

      _createClass(Animated, [{
        key: 'componentDidMount',

        /*:: animation_ref: ?HTMLLIElement */
        value: function componentDidMount() {
          var animation = this.props.animation;

          if (animation && ScrollReveal) {
            ScrollReveal().reveal(this.animation_ref, animation);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var props = Object.assign({}, this.props, _defineProperty({}, refName, function (ref) {
            return _this2.animation_ref = ref;
          }));
          return React.createElement(BaseComponent, props);
        }
      }]);

      return Animated;
    }(React.Component /*:: <AnimateProps> */);

    Animated.displayName = 'Animated(' + getDisplayName(BaseComponent) + ')';
    return Animated;
  };
};


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/animate.js
// module id = 649
// module chunks = 0